import { m } from 'framer-motion';
import { usePopover } from 'minimal-shared/hooks';
import Box from '@mui/material/Box';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import { useRouter } from 'src/routes/hooks';
import { paths, newSearchParams } from 'src/routes/paths';
import { useTranslate } from 'src/locales';
import { increment, updateData, serverTimestamp } from 'src/lib/firebase';
import { toast } from '../snackbar';
import { Iconify } from '../iconify';
import { useReCaptcha } from '../recaptcha';
import { CustomPopover } from '../custom-popover';
import { varTap, varHover, transitionTap } from '../animate';

// ----------------------------------------------------------------------

export function ButtonMoreOptions({
  preview,
  product,
  sx,
  ...other
}) {
  const router = useRouter();
  const {
    t
  } = useTranslate();
  const menuActions = usePopover();
  const verifyCaptcha = useReCaptcha();
  const handleActions = async type => {
    menuActions.onClose();
    const {
      id,
      country,
      sellerID,
      phoneNumber
    } = product;
    if (type === 'profile') {
      router.push(`${paths.user.profile(product.sellerID)}${newSearchParams({
        country
      })}`);
    }
    if (type === 'shop') {
      router.push(`${paths.shop}${newSearchParams({
        country,
        sellerID
      })}`);
    }
    if (type === 'contact') {
      window.open(`https://wa.me/${phoneNumber}`, '_blank', 'noreferrer');
    }
    if (type === 'report') {
      try {
        const isValid = await verifyCaptcha();
        if (!isValid) throw new Error('Captcha detected the use of robots');
        await updateData(`reports/${id}`, {
          sellerID,
          path: `promotions/${id}`,
          totalReports: increment(1),
          reportedAt: serverTimestamp()
        });
        toast.success(t('Product reported'));
      } catch (error) {
        console.error(error);
        toast.error(`${t('An error occurred')}, ${t('please try again')}`);
      }
    }
  };
  const renderMenuActions = () => <CustomPopover open={menuActions.open} onClose={menuActions.onClose} anchorEl={menuActions.anchorEl} slotProps={{
    arrow: {
      placement: 'right-bottom'
    }
  }}>
      <MenuList>
        <MenuItem onClick={() => handleActions('profile')}>
          <Iconify icon="fluent:scan-person-24-filled" />
          {t('Seller Profile')}
        </MenuItem>
        <MenuItem onClick={() => handleActions('shop')}>
          <Iconify icon="solar:shop-linear" />
          {t('Shop')}
        </MenuItem>
        <MenuItem onClick={() => handleActions('contact')}>
          <Iconify icon="ic:round-whatsapp" sx={{
          color: 'success.main'
        }} />
          {t('Whatsapp')}
        </MenuItem>
        <MenuItem onClick={() => handleActions('report')}>
          <Iconify icon="solar:danger-bold" sx={{
          color: 'error.main'
        }} />
          {t('Report content')}
        </MenuItem>
      </MenuList>
    </CustomPopover>;
  return <Box sx={[{
    textAlign: 'center',
    color: 'common.white',
    filter: 'drop-shadow(0 1px 1px rgba(0, 0, 0, .24))'
  }, ...(Array.isArray(sx) ? sx : [sx])]}>
      <IconButton size="small" color="inherit" whileTap={varTap()} component={m.button} whileHover={varHover(1.08)} onClick={menuActions.onOpen} transition={transitionTap()} {...other}>
        <Iconify icon="eva:more-vertical-fill" sx={{
        width: {
          xs: 32,
          md: 26
        },
        height: {
          xs: 32,
          md: 26
        }
      }} />
      </IconButton>

      {!preview && renderMenuActions()}
    </Box>;
}